import React, { useEffect, useRef } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import StripeWidgetSettingsModal from "../WidgetsSettings/StripeWidget/StripeWidgetSettingsModal";

const StripeWidget = ({ value, role, data }) => {
   const containerRef = useRef<HTMLDivElement>(null);

   useEffect(() => {
      const div = document.createElement("div");
      div.innerHTML = value?.base64HtmlPl || "";

      const scriptTag = div.querySelector("script");
      const stripeTag = div.querySelector("stripe-pricing-table");

      if (scriptTag && scriptTag.src) {
         const script = document.createElement("script");
         script.src = scriptTag.src;
         script.async = true;
         document.body.appendChild(script);

         script.onload = () => {
            if (containerRef.current && stripeTag) {
               containerRef.current.innerHTML = "";
               containerRef.current.appendChild(stripeTag);
            }
         };

         return () => {
            document.body.removeChild(script);
         };
      }
   }, [value?.base64HtmlPl]);

   return (
      <Widget
         title={"CustomCode"}
         style={{ boxShadow: "none" }}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               //@ts-ignore
               <SettingsModal
                  widgetId={value.id}
                  widgetName={value.name}
                  icon="setting"
                  deleteIcon="true"
               >
                  <StripeWidgetSettingsModal value={value} data={data} />
               </SettingsModal>
            )
         }
      >
         <div ref={containerRef} />
      </Widget>
   );
};

export default StripeWidget;
